export default __webpack_public_path__ + "static/media/NotoSerifTC-Regular.26c9b43b.otf";